export default {
  options: {
    none: 'Sin código promocional para comenzar',
  },
  buttons: {
    next: 'Siguiente',
    back: 'Atrás',
    skip: 'Omitir',
  },
};
